import DialogFunctions from "../../../core/dialogFunctions";

class ReviewReimbursementDialogController extends DialogFunctions {
  constructor($mdDialog, fineReimbursement) {
    "ngInject";

    super($mdDialog);
    this.fineReimbursement = fineReimbursement;
  }

  confirm(action) {
    this.$mdDialog.hide(action);
  }
}

export default ReviewReimbursementDialogController;



// WEBPACK FOOTER //
// ./src/pages/fineReimbursement/reviewReimbursementDialog/reviewReimbursementDialog.controller.js